import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

const QuestionInstructionBlock = ({ instructions }) => {
  if (!instructions) return null;
  return (
    <div className="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded p-2 text-sm text-blue-900">
      <InformationCircleIcon className="h-4 w-4 mt-0.5 shrink-0" />
      <p className="whitespace-pre-wrap">{instructions}</p>
    </div>
  );
};

export default QuestionInstructionBlock;
